export type ToastTrackingOptions = {
    /** Click event when the toast action button is pressed (if present). */
    dataTrackActionClick?: string;
    dataTrackActionButtonName?: string;
    /** Click event when the toast close (X) button is pressed. */
    dataTrackCloseClick?: string;
    dataTrackCloseButtonName?: string;
    dataTrackLocation?: string;
};

const toastTrackingById = new Map<string, ToastTrackingOptions>();

export const registerToastTracking = (id: string | number | undefined, tracking: ToastTrackingOptions) => {
    if (id === undefined) return;
    toastTrackingById.set(String(id), tracking);
};

export const clearToastTracking = (id: string | number) => {
    toastTrackingById.delete(String(id));
};

const CLOSE_BUTTON_SELECTOR = '[data-close-button], .gz-toast-close';
const ACTION_BUTTON_SELECTOR = '[data-button], .gz-toast-action';

/** Apply Heap data attributes to sonner toast close/action controls. */
export const decorateToastsInDom = () => {
    for (const [id, tracking] of toastTrackingById.entries()) {
        const toastEl = document.querySelector(`[data-sonner-toast][data-toast-id="${id}"]`)
            ?? document.querySelector(`[data-sonner-toast][data-id="${id}"]`);

        if (!toastEl) continue;

        const location = tracking.dataTrackLocation ?? 'skills';

        const closeBtn = toastEl.querySelector(CLOSE_BUTTON_SELECTOR);
        if (closeBtn instanceof HTMLElement && tracking.dataTrackCloseClick) {
            closeBtn.dataset.trackClick = tracking.dataTrackCloseClick;
            closeBtn.dataset.trackLocation = location;
            closeBtn.dataset.trackButtonName = tracking.dataTrackCloseButtonName ?? '';
        }

        const actionBtn = toastEl.querySelector(ACTION_BUTTON_SELECTOR);
        if (actionBtn instanceof HTMLElement && tracking.dataTrackActionClick) {
            actionBtn.dataset.trackClick = tracking.dataTrackActionClick;
            actionBtn.dataset.trackLocation = location;
            actionBtn.dataset.trackButtonName = tracking.dataTrackActionButtonName ?? '';
        }
    }
};
